import React from "react";
import styles from "../../index.module.scss";
import { IoIosArrowBack } from "react-icons/io";
import { ButtonProps } from "antd/es/button";
import { useHistory } from "react-router-dom";
import classNames from "classnames";

export function BackButton({ className, ...props }: ButtonProps) {
    const history = useHistory();

    return (
        <div
            className={classNames(styles.back, className)}
            onClick={history.goBack}
            role="button"
            {...props}>
            <IoIosArrowBack />
        </div>
    );
}
